/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { VoucherConsegnaComunicazioneDTO } from '../model/voucher-consegna-comunicazione-dto';
// @ts-ignore
import { VoucherConsegnaSummaryDTO } from '../model/voucher-consegna-summary-dto';
// @ts-ignore
import { VoucherDTO } from '../model/voucher-dto';
// @ts-ignore
import { VoucherEmissioneSummaryDTO } from '../model/voucher-emissione-summary-dto';
// @ts-ignore
import { VoucherProrogaAnteprimaDTO } from '../model/voucher-proroga-anteprima-dto';
// @ts-ignore
import { VoucherProrogaBandoForm } from '../model/voucher-proroga-bando-form';
// @ts-ignore
import { VoucherProrogaEsitoDTO } from '../model/voucher-proroga-esito-dto';
// @ts-ignore
import { VoucherProrogaForm } from '../model/voucher-proroga-form';
// @ts-ignore
import { VoucherRevocaAnnullamentoForm } from '../model/voucher-revoca-annullamento-form';
// @ts-ignore
import { VoucherRevocaForm } from '../model/voucher-revoca-form';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    VoucherControllerServiceInterface,
    AnnullaRevocaVoucherRequestParams,
    AnteprimaProrogaVoucherBandoRequestParams,
    ComunicazioneConsegnaVoucherRequestParams,
    ConsegnaVoucherRequestParams,
    DettaglioVoucherRequestParams,
    DownloadVoucherPdfRequestParams,
    GeneraVoucherRequestParams,
    ListaVoucherRequestParams,
    ProrogaVoucherRequestParams,
    ProrogaVoucherBandoRequestParams,
    RevocaVoucherRequestParams
} from './voucher-controller.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class VoucherControllerService extends BaseService implements VoucherControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Annulla la revoca attiva di un voucher (D-61), solo SUPERADMIN
     * Ammesso solo per le revoche SOLO_NON_SPESO e BLOCCA_E_REGISTRA (BLOCCA_E_STORNA -&gt; 422): il voucher torna allo stato precedente la revoca, la revoca resta nello storico come annullata e il voucher si puo\&#39; revocare di nuovo. Motivo obbligatorio e version del voucher (stale -&gt; 409). Dopo l\&#39;annullamento parte l\&#39;evento VOUCHER_RIATTIVATO (non per i voucher ASSEGNATO).
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/annulla-revoca
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public annullaRevocaVoucher(requestParameters: AnnullaRevocaVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherDTO>;
    public annullaRevocaVoucher(requestParameters: AnnullaRevocaVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherDTO>>;
    public annullaRevocaVoucher(requestParameters: AnnullaRevocaVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherDTO>>;
    public annullaRevocaVoucher(requestParameters: AnnullaRevocaVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling annullaRevocaVoucher.');
        }
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling annullaRevocaVoucher.');
        }
        const voucherRevocaAnnullamentoForm = requestParameters?.voucherRevocaAnnullamentoForm;
        if (voucherRevocaAnnullamentoForm === null || voucherRevocaAnnullamentoForm === undefined) {
            throw new Error('Required parameter voucherRevocaAnnullamentoForm was null or undefined when calling annullaRevocaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/annulla-revoca`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: voucherRevocaAnnullamentoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Anteprima della proroga di bando (nessuna scrittura)
     * Stessi parametri della proroga di bando; il motivo non e\&#39; richiesto. Ritorna quanti voucher verrebbero prorogati e quanti saltati, con la scadenza minima e massima risultanti.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/proroga/anteprima
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public anteprimaProrogaVoucherBando(requestParameters: AnteprimaProrogaVoucherBandoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherProrogaAnteprimaDTO>;
    public anteprimaProrogaVoucherBando(requestParameters: AnteprimaProrogaVoucherBandoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherProrogaAnteprimaDTO>>;
    public anteprimaProrogaVoucherBando(requestParameters: AnteprimaProrogaVoucherBandoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherProrogaAnteprimaDTO>>;
    public anteprimaProrogaVoucherBando(requestParameters: AnteprimaProrogaVoucherBandoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling anteprimaProrogaVoucherBando.');
        }
        const voucherProrogaBandoForm = requestParameters?.voucherProrogaBandoForm;
        if (voucherProrogaBandoForm === null || voucherProrogaBandoForm === undefined) {
            throw new Error('Required parameter voucherProrogaBandoForm was null or undefined when calling anteprimaProrogaVoucherBando.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/proroga/anteprima`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherProrogaAnteprimaDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: voucherProrogaBandoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Canali su cui partirà la comunicazione al cittadino alla consegna dei voucher
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/consegna/comunicazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public comunicazioneConsegnaVoucher(requestParameters: ComunicazioneConsegnaVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherConsegnaComunicazioneDTO>;
    public comunicazioneConsegnaVoucher(requestParameters: ComunicazioneConsegnaVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherConsegnaComunicazioneDTO>>;
    public comunicazioneConsegnaVoucher(requestParameters: ComunicazioneConsegnaVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherConsegnaComunicazioneDTO>>;
    public comunicazioneConsegnaVoucher(requestParameters: ComunicazioneConsegnaVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling comunicazioneConsegnaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/consegna/comunicazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherConsegnaComunicazioneDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Consegna i voucher (ASSEGNATO→DA_CONSUMARE) + comunicazione cittadino (bando → VOUCHER_CONSEGNATI)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/consegna
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public consegnaVoucher(requestParameters: ConsegnaVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherConsegnaSummaryDTO>;
    public consegnaVoucher(requestParameters: ConsegnaVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherConsegnaSummaryDTO>>;
    public consegnaVoucher(requestParameters: ConsegnaVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherConsegnaSummaryDTO>>;
    public consegnaVoucher(requestParameters: ConsegnaVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling consegnaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/consegna`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherConsegnaSummaryDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Dettaglio di un voucher del bando
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public dettaglioVoucher(requestParameters: DettaglioVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherDTO>;
    public dettaglioVoucher(requestParameters: DettaglioVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherDTO>>;
    public dettaglioVoucher(requestParameters: DettaglioVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherDTO>>;
    public dettaglioVoucher(requestParameters: DettaglioVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling dettaglioVoucher.');
        }
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling dettaglioVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download del PDF+QR di un voucher del bando
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/pdf
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadVoucherPdf(requestParameters: DownloadVoucherPdfRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public downloadVoucherPdf(requestParameters: DownloadVoucherPdfRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public downloadVoucherPdf(requestParameters: DownloadVoucherPdfRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public downloadVoucherPdf(requestParameters: DownloadVoucherPdfRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/pdf' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling downloadVoucherPdf.');
        }
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling downloadVoucherPdf.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/pdf',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pdf`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Emette i voucher dalle righe graduatoria finanziate (bando → VOUCHER_ASSEGNATI)
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/genera
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public generaVoucher(requestParameters: GeneraVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherEmissioneSummaryDTO>;
    public generaVoucher(requestParameters: GeneraVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherEmissioneSummaryDTO>>;
    public generaVoucher(requestParameters: GeneraVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherEmissioneSummaryDTO>>;
    public generaVoucher(requestParameters: GeneraVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling generaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/genera`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherEmissioneSummaryDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista dei voucher del bando (vista backoffice completa)
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listaVoucher(requestParameters: ListaVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<VoucherDTO>>;
    public listaVoucher(requestParameters: ListaVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<VoucherDTO>>>;
    public listaVoucher(requestParameters: ListaVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<VoucherDTO>>>;
    public listaVoucher(requestParameters: ListaVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling listaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<VoucherDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Proroga la scadenza di un voucher del bando (GIORNI o DATA)
     * Forma GIORNI: +N giorni alla scadenza attuale; forma DATA: nuova scadenza unica (fine giornata). Solo in avanti; voucher con credito residuo (ASSEGNATO, DA_CONSUMARE, PARZIALMENTE_CONSUMATO), anche se gia\&#39; scaduti. Motivo obbligatorio e version del voucher (stale -&gt; 409 con residuo e version correnti). Dopo la proroga il PDF viene rigenerato e parte l\&#39;evento VOUCHER_PROROGATO. SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/proroga
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public prorogaVoucher(requestParameters: ProrogaVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherDTO>;
    public prorogaVoucher(requestParameters: ProrogaVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherDTO>>;
    public prorogaVoucher(requestParameters: ProrogaVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherDTO>>;
    public prorogaVoucher(requestParameters: ProrogaVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling prorogaVoucher.');
        }
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling prorogaVoucher.');
        }
        const voucherProrogaForm = requestParameters?.voucherProrogaForm;
        if (voucherProrogaForm === null || voucherProrogaForm === undefined) {
            throw new Error('Required parameter voucherProrogaForm was null or undefined when calling prorogaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/proroga`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: voucherProrogaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Proroga la scadenza di tutti i voucher prorogabili del bando
     * Stesse regole della proroga del singolo voucher, applicate a tutti i voucher con credito residuo del bando. I voucher gia\&#39; oltre la data (o senza scadenza con forma GIORNI) restano invariati e sono contati in \&#39;saltati\&#39;. Su un bando con scadenza a data fissa aggiorna anche la data della policy. Motivo obbligatorio.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/proroga
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public prorogaVoucherBando(requestParameters: ProrogaVoucherBandoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherProrogaEsitoDTO>;
    public prorogaVoucherBando(requestParameters: ProrogaVoucherBandoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherProrogaEsitoDTO>>;
    public prorogaVoucherBando(requestParameters: ProrogaVoucherBandoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherProrogaEsitoDTO>>;
    public prorogaVoucherBando(requestParameters: ProrogaVoucherBandoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling prorogaVoucherBando.');
        }
        const voucherProrogaBandoForm = requestParameters?.voucherProrogaBandoForm;
        if (voucherProrogaBandoForm === null || voucherProrogaBandoForm === undefined) {
            throw new Error('Required parameter voucherProrogaBandoForm was null or undefined when calling prorogaVoucherBando.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/proroga`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherProrogaEsitoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: voucherProrogaBandoForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Revoca un voucher del bando (ANNULLATO) secondo la modalita\&#39; di revoca della policy
     * Richiede la revoca abilitata sul bando (revoca_voucher_modalita), un motivo non vuoto e la version del voucher (stale -&gt; 409 con residuo e version correnti). Modalita\&#39;: SOLO_NON_SPESO (rifiuta se c\&#39;e\&#39; importo speso), BLOCCA_E_REGISTRA (registra l\&#39;importo da recuperare), BLOCCA_E_STORNA (annulla i consumi se non ancora rendicontati). Dopo la revoca parte l\&#39;evento VOUCHER_REVOCATO (non per i voucher ASSEGNATO). SUPERADMIN/OP_COMUNE scopati al comune del bando.
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/voucher/{idVoucher}/revoca
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public revocaVoucher(requestParameters: RevocaVoucherRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<VoucherDTO>;
    public revocaVoucher(requestParameters: RevocaVoucherRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<VoucherDTO>>;
    public revocaVoucher(requestParameters: RevocaVoucherRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<VoucherDTO>>;
    public revocaVoucher(requestParameters: RevocaVoucherRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling revocaVoucher.');
        }
        const idVoucher = requestParameters?.idVoucher;
        if (idVoucher === null || idVoucher === undefined) {
            throw new Error('Required parameter idVoucher was null or undefined when calling revocaVoucher.');
        }
        const voucherRevocaForm = requestParameters?.voucherRevocaForm;
        if (voucherRevocaForm === null || voucherRevocaForm === undefined) {
            throw new Error('Required parameter voucherRevocaForm was null or undefined when calling revocaVoucher.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/voucher/${this.configuration.encodeParam({name: "idVoucher", value: idVoucher, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/revoca`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<VoucherDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: voucherRevocaForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
